import axios from 'axios';
import api, { API_URL } from '../utils/apiConfig';

export const intakeAPI = {
  createLink: async (payload) => {
    const response = await api.post('/intake/create-link', payload);
    return response.data?.data;
  },

  getPublicByToken: async (token) => {
    const response = await axios.get(`${API_URL}/intake/${token}`);
    return response.data?.data;
  },

  saveDraft: async (token, answers) => {
    const response = await axios.put(`${API_URL}/intake/${token}/draft`, { answers });
    return response.data?.data;
  },

  submit: async (token, answers) => {
    const response = await axios.post(`${API_URL}/intake/${token}/submit`, { answers });
    return response.data?.data;
  },

  markReviewed: async (token) => {
    const response = await api.post(`/intake/${token}/review`);
    return response.data?.data;
  },

  getLatestForPatient: async (patientId) => {
    const response = await api.get(`/intake/patient/${patientId}/latest`);
    return response.data?.data;
  },

  getByPatientAndId: async (patientId, intakeId) => {
    const response = await api.get(`/intake/patient/${patientId}/${intakeId}`);
    return response.data?.data;
  },

  getArchive: async (params = {}) => {
    const response = await api.get('/intake/archive', { params });
    return response.data;
  },

  attachToPatient: async (intakeId, patientId) => {
    const response = await api.post(`/intake/${intakeId}/attach`, { patientId });
    return response.data?.data;
  },
};

export default intakeAPI;
